import { get, maxBy, minBy, findIndex, flatMap, omit } from 'lodash-es';
import { INCENTIVE_CATEGORY } from 'site-modules/shared/constants/incentives';

export const getTypeTitle = sourceType => (sourceType === 'UNKNOWN' ? '-' : '');

export const getMaxRebatesIncentive = rebates => maxBy(get(rebates, 'CUSTOMERCASH', []), rebate => rebate.rebateAmount);

export const getMinFinancingIncentive = financing => minBy(get(financing, 'ALL', []), incentive => incentive.apr);

/**
 * Returns array of 0 and index of the first make whose first character is different than the first character of the first make that comes from a fixed list of makes
 *
 * Example: getTypeAdIndexes([{ makeName: 'Alfa Romeo' }, { makeName: 'Audi' }, { makeName: 'BMW' }, { makeName: 'Cadillac' }]) => [0, 2]
 *
 * @param {Array} incentives Alphabetized by make
 * @returns {*|number[]}
 */
export const getTypeAdIndexes = incentives => {
  const makesList = incentives.map(({ makeName }) => makeName);

  return [0, findIndex(makesList, makeName => makeName[0] !== makesList[0][0])];
};

export const removeStandardAprIncentives = incentives => {
  const filteredIncentives = {
    ...incentives,
    financing: incentives.financing.filter(({ subtype }) => !['Standard APR'].includes(subtype)),
  };

  return {
    ...filteredIncentives,
    numIncentives: incentives.numIncentives - incentives.financing.length + filteredIncentives.financing.length,
  };
};

function isLeaseTransactionType(transactionTypes) {
  return transactionTypes && transactionTypes.length === 1 && transactionTypes[0] === 'LEASE';
}

function isCashTransactionType({ transactionTypes, type }) {
  return (
    transactionTypes &&
    transactionTypes.includes('LEASE') &&
    ['CASH', 'FINANCE'].some(transactionType => transactionTypes.includes(transactionType)) &&
    ['CUSTOMER_CASH', 'CUSTOMER_CASH_AND_APR', 'CUSTOMER_CASH_OR_APR', 'PERCENTAGE'].includes(type)
  );
}

export function filterPanelIncentives(incentives) {
  const flatIncentives = flatMap(omit(incentives, 'numIncentives'));
  const carIncentives = {
    bonus: flatIncentives.filter(
      ({ categories, transactionTypes, type }) =>
        (get(categories, '[0].category') === INCENTIVE_CATEGORY.REBATES && !isLeaseTransactionType(transactionTypes)) ||
        isCashTransactionType({ transactionTypes, type })
    ),
    financing: flatIncentives.filter(
      ({ categories, transactionTypes, type }) =>
        get(categories, '[0].category') === INCENTIVE_CATEGORY.FINANCING &&
        !isLeaseTransactionType(transactionTypes) &&
        !isCashTransactionType({ transactionTypes, type })
    ),
    lease: flatIncentives.filter(({ transactionTypes }) => isLeaseTransactionType(transactionTypes)),
    other: flatIncentives.filter(
      ({ categories, transactionTypes, type }) =>
        get(categories, '[0].category') === INCENTIVE_CATEGORY.OTHER &&
        !isLeaseTransactionType(transactionTypes) &&
        !isCashTransactionType({ transactionTypes, type })
    ),
  };

  carIncentives.numIncentives =
    carIncentives.bonus.length +
    carIncentives.financing.length +
    carIncentives.lease.length +
    carIncentives.other.length;

  return removeStandardAprIncentives(carIncentives);
}
